document.addEventListener('DOMContentLoaded', function() {
  initializeSections();
});

// Only define the class if it doesn't already exist
if (typeof window.TabbedInformationSwiper === 'undefined') {
window.TabbedInformationSwiper = class TabbedInformationSwiper {
constructor(section) {
this.section = section;
this.sectionId = this.section.dataset.sectionId;
this.tabs = this.section.querySelectorAll('.tabbed-information__tab');
this.swiper = this.section.querySelector(`#tabbed-information-swiper-${this.sectionId}`);
this.contentWrapper = this.section.querySelector('[data-content-wrapper]');
this.closeButtons = this.section.querySelectorAll('.tabbed-information__slide-close__button');
if (!this.swiper) return;
this.currentTab = 0;
this.isInitialized = false;
this.isTransitioning = false;
this.retryCount = 0;
this.maxRetries = 10; // 10 × 500ms = 5s max
// Store instance on section element
this.section.swiperInstance = this;
// Bind methods to preserve context
this.handleTabClick = this.handleTabClick.bind(this);
this.updateActiveTab = this.updateActiveTab.bind(this);
this.handleCloseClick = this.handleCloseClick.bind(this);
this.init();
    }

init() {
if (this.isInitialized) return;

// Check if Swiper is defined and the element is a proper Swiper element
if (typeof customElements === 'undefined' ||
!customElements.get('swiper-container') ||
typeof this.swiper.initialize === 'undefined') {
if (this.retryCount >= this.maxRetries) {
console.warn('Swiper Element failed to load after ' + this.maxRetries + ' retries.');
return;
        }
this.retryCount++;
console.log('Swiper Element not available yet, will retry (' + this.retryCount + '/' + this.maxRetries + ')');
setTimeout(() => this.init(), 500);
return;
      }
// Initialize Swiper with unique parameters for this instance
Object.assign(this.swiper, {
injectStyles: [`
          .swiper {
            width: 100%;
            height: 100%;
            overflow: visible;
          }
          .swiper-slide {
            height: auto;
            position: relative;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.4s ease, transform 0.4s ease;
          }
          .swiper-slide-active {
            opacity: 1;
            transform: translateY(0);
          }
        `],
speed: 600,
slidesPerView: 1,
spaceBetween: 30,
effect: 'slide',
autoHeight: true,
allowTouchMove: false,
init: true,
observer: true,
observeParents: true,
initialSlide: this.swiper.hasAttribute('initial-slide') ? parseInt(this.swiper.getAttribute('initial-slide')) : 0
      });

// Initialize this specific instance
this.swiper.initialize();

// Force update after initialization
setTimeout(() => {
if (this.swiper.swiper) {
this.swiper.swiper.update();
        }
      }, 100);
// Add event listeners
this.tabs.forEach((tab, index) => {
tab.addEventListener('click', () => this.handleTabClick(index));
      });

// Add close button event listeners
this.closeButtons.forEach(button => {
button.addEventListener('click', this.handleCloseClick);
      });

this.swiper.addEventListener('swiper-slidechange', this.updateActiveTab);

// Set initial active state only if we're not in no-default-selection mode
if (!this.swiper.hasAttribute('initial-slide')) {
this.updateActiveTab();
      }

this.isInitialized = true;
    }

handleTabClick(index) {
if (!this.swiper.swiper || this.isTransitioning) return;
this.isTransitioning = true;
this.currentTab = index;
// Show content wrapper with fade in
if (this.contentWrapper) {
this.contentWrapper.classList.remove('is-hidden');
      }
// Add a small delay before sliding to allow fade in
setTimeout(() => {
this.swiper.swiper.slideTo(index);
this.updateActiveTab();
this.isTransitioning = false;
      }, 50);
    }

updateActiveTab() {
// Remove active class from all tabs
this.tabs.forEach(tab => tab.classList.remove('is-active'));
// Get current index either from swiper or stored current tab
const currentIndex = this.swiper.swiper ? this.swiper.swiper.activeIndex : this.currentTab;
// Add active class to current tab
if (this.tabs[currentIndex]) {
this.tabs[currentIndex].classList.add('is-active');
      }

// Update slide visibility
const slides = this.swiper.querySelectorAll('swiper-slide');
slides.forEach((slide, i) => {
if (i === currentIndex) {
slide.classList.add('swiper-slide-active');
        } else {
slide.classList.remove('swiper-slide-active');
        }
      });
    }

handleCloseClick() {
if (this.isTransitioning) return;
this.isTransitioning = true;
// Add fade out animation
if (this.contentWrapper) {
this.contentWrapper.style.opacity = '0';
this.contentWrapper.style.transform = 'translateY(20px)';
// Wait for animation to complete before hiding
setTimeout(() => {
this.contentWrapper.classList.add('is-hidden');
this.contentWrapper.style.opacity = '';
this.contentWrapper.style.transform = '';
// Remove active class from all tabs
this.tabs.forEach(tab => tab.classList.remove('is-active'));
// Reset swiper to initial state
if (this.swiper.swiper) {
this.swiper.swiper.slideTo(this.swiper.hasAttribute('initial-slide') ?
parseInt(this.swiper.getAttribute('initial-slide')) : 0);
          }
this.isTransitioning = false;
        }, 400); // Match the transition duration from CSS
      } else {
this.isTransitioning = false;
      }
    }

destroy() {
if (!this.isInitialized) return;
// Remove event listeners
this.tabs.forEach(tab => {
tab.removeEventListener('click', this.handleTabClick);
      });
this.closeButtons.forEach(button => {
button.removeEventListener('click', this.handleCloseClick);
      });
this.swiper.removeEventListener('swiper-slidechange', this.updateActiveTab);
// Destroy Swiper instance
if (this.swiper.swiper) {
this.swiper.swiper.destroy();
      }
this.isInitialized = false;
    }
  }
}

function initializeSections() {
document.querySelectorAll('.tabbed-information').forEach((section) => {
if (!section.swiperInstance) {
new window.TabbedInformationSwiper(section);
    }
  });
}

// Initialize on DOM Content Loaded
document.addEventListener('DOMContentLoaded', initializeSections);

// Handle section load
document.addEventListener('shopify:section:load', (event) => {
const section = event.target;
if (section.classList.contains('tabbed-information')) {
new window.TabbedInformationSwiper(section);
  }
});

// Handle section unload
document.addEventListener('shopify:section:unload', (event) => {
const section = event.target;
if (section.classList.contains('tabbed-information')) {
if (section.swiperInstance) {
section.swiperInstance.destroy();
    }
  }
});

// Re-initialize on Shopify theme editor events
document.addEventListener('shopify:section:select', initializeSections);
document.addEventListener('shopify:section:deselect', initializeSections);
document.addEventListener('shopify:block:select', initializeSections);
document.addEventListener('shopify:block:deselect', initializeSections);